// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";

function s(prim) {
  return prim;
}

function Error404Page(props) {
  return JsxRuntime.jsxs("main", {
              children: [
                JsxRuntime.jsx("title", {
                      children: "Not found"
                    }),
                JsxRuntime.jsx("h1", {
                      children: "Page not found",
                      className: "heading-block"
                    }),
                JsxRuntime.jsxs("p", {
                      children: [
                        JsxRuntime.jsx("h3", {
                              children: "Sorry.... " + '😔'
                            }),
                        "We couldn't find what you were looking for.",
                        JsxRuntime.jsx("br", {}),
                        JsxRuntime.jsx("br", {})
                      ],
                      className: "paragraph-block"
                    })
              ],
              className: "main-block"
            });
}

var make = Error404Page;

export {
  s ,
  make ,
}
/* react/jsx-runtime Not a pure module */
